import { render, staticRenderFns } from "./NemesesHighscoreComponent.vue?vue&type=template&id=e2e2b3b0&"
import script from "./NemesesHighscoreComponent.vue?vue&type=script&lang=ts&"
export * from "./NemesesHighscoreComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports